import { literal, number, object, string } from "superstruct";

export const GiftCardRewardSchema = object({
    type: literal("gift_card"),
    initialValue: number(),
    code: string(),
    balance: number(),
});
